import { createFileRoute } from '@tanstack/react-router';
import { type AggregateBreadcrumb, buildBreadcrumb } from '@interxfi/app-components/components/router-breadcrumbs/router-breadcrumbs';
import { UTC_FIX_SESSION_BASE_PATH } from '../../../../../../../../../features/dtcc/utc-fix-session/utc-fix-session-routing';

export const Route = createFileRoute(
  '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/trade/utc-fix-session/_utc-fix-session',
)({
  loader: () =>
    ({
      breadcrumb: buildBreadcrumb({
        id: 'utc-fix-session-list',
        label: 'Trades',
        to: UTC_FIX_SESSION_BASE_PATH,
      }),
    }) satisfies AggregateBreadcrumb,
});
